import { styled } from '@mui/material/styles';
import { Card, CardHeader, CardContent, CardActions, Button, List, ListItem, ListItemText } from '@mui/material';
import { commonStyles } from '../../assets/styles/commonStyles';

export const StyledCard = styled(Card)(({ theme }) => ({
  ...commonStyles.enhancedCard(theme),
  ...commonStyles.standardCardDimensions(theme),
  padding: theme.spacing(2),
}));

export const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  '& .MuiCardHeader-title': {
    ...commonStyles.responsiveText(theme),
    fontWeight: 600,
    
    [theme.breakpoints.up('md')]: {
      fontSize: '1.25rem',
    },
    
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.1rem',
    },
  },
}));

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  overflow: 'auto',
  paddingTop: '0px',
  marginTop: '-15px',
  flex: 1,
  
  '&:last-child': {
    paddingBottom: theme.spacing(1),
  },
}));

export const StyledList = styled(List)(({ theme }) => ({
  padding: 0,
}));

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  ...commonStyles.enhancedListItem(theme),
  padding: theme.spacing(0.5, 0),
}));

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '& .MuiListItemText-primary': {
    ...commonStyles.responsiveText(theme),
  },
}));

export const StyledCardActions = styled(CardActions)(({ theme }) => ({
  alignSelf: 'stretch',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
  flexWrap: 'nowrap',
  
  [theme.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
  },
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  ...commonStyles.enhancedButton(theme),
  fontSize: '0.875rem',
  padding: theme.spacing(1, 2),
  
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.75rem',
    padding: theme.spacing(0.75, 1.5),
  },
  
  [theme.breakpoints.down('xs')]: {
    fontSize: '0.75rem',
    padding: theme.spacing(0.75, 1.5),
  },
}));

export const ClearButton = styled(Button)(({ theme }) => ({
  ...commonStyles.enhancedButton(theme),
  fontSize: '0.875rem',
  padding: theme.spacing(1, 2),
  
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.75rem',
    padding: theme.spacing(0.75, 1.5),
  },
  
  [theme.breakpoints.down('xs')]: {
    fontSize: '0.75rem',
    padding: theme.spacing(0.75, 1.5),
  },
}));
